import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";

import {
  ref,
  onMounted,
  defineComponent,
  reactive,
  computed,
} from "@vue/composition-api";
import { itemRouteBuilder, NamedRts } from "@/router";

export default defineComponent({
  name: "clientFieldShow",
  components: {
    LoadingAnimation,
  },
  props: {
    clientFieldId: {
      type: String,
      required: true,
    },
  },

  setup(props, ctx) {
    let $store = ctx.root.$store;

    let dataLoaded = ref(false);
    let loadingMessage = ref("Loading Field...");

    const clientField = computed(() => {
      return $store.getters.clientField;
    });

    const editRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.clientFieldEditForm, id);
    };

    const clientShowRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.clientShow, id);
    };

    const workOrderShowRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.workOrderDetails, id);
    };

    onMounted(() => {
      const jsConn = new JSConn();

      jsConn.formParams = {
        id: props.clientFieldId,
      };

      $store.dispatch("needClientField", jsConn).then(() => {
        dataLoaded.value = true;
      });
    });

    return {
      dataLoaded,
      loadingMessage,

      clientField,
      editRouteBuilder,
      clientShowRouteBuilder,
      workOrderShowRouteBuilder,
    };
  },
});
